import { NEW_PLACE_TWEAKS_EXPERIMENT } from '@/constants/experimentConstants';
import { useAppSelector } from '@/hooks';
import { useGetAmplitudeExperimentVariant } from '@/hooks/useAmplitudeExperiment';
import { useListCardsV2 } from '@/hooks/useListCardsV2';
import LegacyServiceCard from './LegacyServiceCard';
import { ServiceCardProps } from './ServiceListCard.types';
import ServiceListCardTest from './ServiceListCardTest';

import ServiceListCard from './ServiceListCard';

const ServiceListCardWrapper = (props: ServiceCardProps) => {
  const getVariant = useGetAmplitudeExperimentVariant();
  const flags = useAppSelector((state) => state.flags);
  const placePageTweaksFlag =
    flags[NEW_PLACE_TWEAKS_EXPERIMENT]?.value === 'on' || getVariant(NEW_PLACE_TWEAKS_EXPERIMENT)?.value === 'on';
  const isListCardsV2 = useListCardsV2();

  if (placePageTweaksFlag) {
    return <ServiceListCardTest {...props} />;
  }

  return isListCardsV2 ? <ServiceListCard {...props} /> : <LegacyServiceCard {...props} />;
};

export default ServiceListCardWrapper;
